module.exports = __webpack_public_path__ + "img/face.e4e92754.png";